import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useRef } from 'react';
import type { Aula } from '@/types/masterclass';

interface MasterClassPlayerProps {
  aula: Aula | null;
  onTimeUpdate: (time: number) => void;
  onEnded: () => void;
}

export function MasterClassPlayer({ aula, onTimeUpdate, onEnded }: MasterClassPlayerProps) {
  useLanguage();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  if (!aula) {
    return (
      <div className="aspect-video bg-black rounded-lg flex items-center justify-center">
        <p className="text-white/60">{translateInterfaceText("Selecione uma aula para começar")}</p>
      </div>
    );
  }

  const vimeoUrl = `https://player.vimeo.com/video/${aula.videoSource.videoId}?badge=0&autopause=0&player_id=0&app_id=58479`;

  return (
    <div 
      className="mc-player aspect-video bg-black rounded-xl overflow-hidden" 
      style={{ border: '1px solid var(--gray-200)' }}
    >
      <iframe
        ref={iframeRef}
        src={vimeoUrl}
        className="w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title={aula.titulo}
      />
    </div>
  );
}
